import { RequestService } from '@tcc-online/request-service';

const URL = '/participant/projects';

const ProjectService = {
    getProjects,
    getProject,
    giveConsent,
};

async function getProjects() {
    return await RequestService.get(URL);
}

async function getProject(id: number) {
    return await RequestService.get(`${URL}/${id}`);
}

async function giveConsent(id: number) {
    return await RequestService.patch(`${URL}/${id}`, {
        consent: true,
    });
}

export default ProjectService;
